import queryString from 'query-string'
import uuid from 'uuid/v1'

import { UserType, UserTypeValueOf } from 'main/util/user'

export function parseIntSafe(str?: string) {
  return !!str
    ? (() => {
        try {
          return Number.parseInt(str, 10)
        } catch (err) {
          return
        }
      })()
    : undefined
}

export interface IAuthParams {
  defaultEmail?: string
  redirectTo?: string
  type?: UserType
  schoolId?: number
  externalSchoolId?: number
  sessionId: string
}

const EMAIL_KEY = 'email'
const REDIRECT_KEY = 'redirect_to'
const TYPE_KEY = 'type'
const SCHOOL_ID_KEY = 'school_id'
const EXTERNAL_SCHOOL_ID_KEY = 'exts_id'
const SESSION_ID = 'sid'

function isQPSafe(qp: string | string[] | null) {
  return !!qp && !Array.isArray(qp)
}

export function extractParams(search: string = window.location.search): IAuthParams {
  const queryParams = queryString.parse(search)

  // email
  const emailFromQueryParams = queryParams[EMAIL_KEY]
  const defaultEmail = isQPSafe(emailFromQueryParams) ? (emailFromQueryParams as string) : undefined

  // redirect_to
  const redirectFromQueryParam = queryParams[REDIRECT_KEY]
  const redirectTo = isQPSafe(redirectFromQueryParam)
    ? (redirectFromQueryParam as string)
    : undefined

  // type
  const typeFromQueryParams = queryParams[TYPE_KEY]
  const typeString = isQPSafe(typeFromQueryParams) ? (typeFromQueryParams as string) : undefined
  const type = !!typeString ? UserTypeValueOf(typeString) : undefined

  // school_id
  const schoolIdFromQueryParam = queryParams[SCHOOL_ID_KEY]
  const schoolId = isQPSafe(schoolIdFromQueryParam)
    ? parseIntSafe(schoolIdFromQueryParam as string)
    : undefined

  // exts_id
  const externalSchoolIdIdFromQueryParam = queryParams[EXTERNAL_SCHOOL_ID_KEY]
  const externalSchoolId = isQPSafe(externalSchoolIdIdFromQueryParam)
    ? parseIntSafe(externalSchoolIdIdFromQueryParam as string)
    : undefined

  // sid
  const sessionIdFromQueryParam = queryParams[SESSION_ID]
  const sessionId = isQPSafe(sessionIdFromQueryParam)
    ? (sessionIdFromQueryParam as string)
    : undefined

  return {
    defaultEmail,
    redirectTo,
    type,
    schoolId,
    externalSchoolId,
    sessionId: !!sessionId ? sessionId : uuid(),
  }
}
